import { AllowedBranches, AllowedNonCorps} from '@pos-app/data';
export function getCombinedBranches(allowedCropBranches: AllowedBranches[], allowedNonCropBranches: AllowedNonCorps[]) {
  return allowedCropBranches
    ? allowedCropBranches
        ?.map((branch) => {
          return {
            BranchCode: branch?.branchCode.trim(),
            BranchDescription: branch?.branchName,
          };
        })
        .concat(
          allowedNonCropBranches?.map((branch: any) => {
            return {
              BranchCode: branch?.partnerCode.toString(),
              BranchDescription: branch?.partnerName,
            };
          })
        )
    : allowedNonCropBranches?.map((branch: any) => {
        return {
          BranchCode: branch?.partnerCode.toString(),
          BranchDescription: branch?.partnerName,
        };
      }) || [];
}
